import project1 from './assets/images/webapp.png'
import project2 from './assets/images/travelglobe.png'
import project3 from './assets/images/parkhub.png'
import project4 from './assets/images/onlinefoodordering.png'
import project5 from './assets/images/tictactoe.png'
import project6 from './assets/images/SQL_Generator.png'
const header = {
  homepage: 'https://dalvirushikesh.github.io/portfolio/',
  title: '',
}
const about = {
  name: 'Rushikesh Dalvi',
  role: 'Software Engineer',
  description:'I’m Rushikesh, currently actively looking for software engineer roles in the USA. My projects include UX design and Full-Stack Software Development. Being comfortable with code allows me to rapidly prototype and validate experiences. In my spare time, I like to play video games, and I’m always down for hearing about new technical projects, so feel free to drop me a line.',
  resume: 'https://drive.google.com/file/d/1xr63O1WPKNaSzWGfGKFI1D2RweMAjGW8/view?usp=drive_link',
  social: {
    linkedin: 'https://www.linkedin.com/in/rushikesh-dalvi-/',
    github: 'https://github.com/dalvirushikesh',
  },
}
const projects = [
  {
    name:'SQL Query Generator Application Using Gemini AI',
    description: 'A web application that generates SQL queries using Gemini AI.',
    stack: [
      'Python', 'Flask', 'SQLAlchemy', 'Streamlit', 'SQL', 'Gemini AI','LLM' ],
    sourceCode: 'https://github.com/dalvirushikesh/Google_Gemini_SQL_Query_Generator',
    image:project6
  },
  {
    name: 'Web App',
    description: 'A scalable web application with user account management and cloud integration.',
    stack: [
      'Node.js', 'AWS', 'CI/CD', 'HCL', 'YAML', 'Packer', 'Terraform', 'CloudFormation', 'Docker', 'Jenkins', 'GitHub Actions', 'StatsD', 'CloudWatch', 'S3', 'RDS', 'EC2', 'Lambda', 'SNS', 'Load Balancer'
    ],
    sourceCode: 'https://github.com/dalvirushikesh/webapp',
    livePreview: 'https://github.com/dalvirushikesh/webapp',
    image: project1
  },
  {
    name: 'Travel Globe',
    description: 'A travel application built with the MERN stack to streamline trip planning.',
    stack: [
      'Node.js', 'express.js', 'React', 'Redux', 'GraphQL', 'MongoDB', 'styled-components', 'JWT', 'Bcrypt', 'React Hooks', 'Material UI', 'Jest', 'Enzyme'
    ],
    sourceCode: 'https://github.com/dalvirushikesh/Web-Design-MERN-Project',
    livePreview: 'https://travel-globe-drks4uy9d-dalvirushikeshs-projects.vercel.app/home',
    image: project2
  },
  {
    name: 'Park Hub',
    description: 'A parking application with user-friendly design and insurance coverage features.',
    stack: ['Figma', 'Balsamiq', 'HTML', 'CSS', 'UX Design', 'Wireframes', 'Prototypes', 'High-fidelity mockups'],
    sourceCode: 'https://github.com/dalvirushikesh/parkhub',
    livePreview: 'https://www.figma.com/proto/Nd8y17XGKGFTDtk4AIskun/ParkHub?type=design&node-id=128-599&t=PuZzJkxoQJIDgh9i-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=6%3A5&show-proto-sidebar=1',
    image: project3
  },
  {
    name: 'Food Ordering System',
    description: 'A database system for online food ordering and delivery management.',
    stack: ['Oracle SQL', 'PL/SQL', 'SQL Developer', 'ER Diagram', 'Normalization', 'Views', 'Stored Procedures', 'Functions'],
    sourceCode: 'https://github.com/dalvirushikesh/DMDD_Project_Online_Food_Ordering_System',
    livePreview: 'https://github.com/dalvirushikesh/DMDD_Project_Online_Food_Ordering_System',
    image: project4
  },
  {
    name: 'Tic Tac Toe Game',
    description: 'A classic tic-tac-toe game developed using PL/SQL and SQL.',
    stack: ['PL/SQL', 'SQL', 'Normalization', 'Views', 'Stored Procedures', 'Functions'],
    sourceCode: 'https://github.com/dalvirushikesh/Tic-Tac-Toe',
    livePreview: 'https://github.com/dalvirushikesh/Tic-Tac-Toe',
    image: project5
  }
  
];

const experience = [
  {
    company: 'Walmart',
    role: 'Software Engineer',
    duration: 'Aug 2024 - Current',
  },
  {
    company:'IpserLab',
    role:'Software Engineer Intern',
    duration:'Sep 2023 - Jan 2024'
  },
  {
    company: 'Tech Mahindra',
    role: 'Software Engineer',
    duration: 'Dec 2018 - Dec 2021',
  }

]

const education = [
  {
    institution: 'Northeastern University',
    degree: 'Master of Science in Information Systems',
    duration: 'Jan 2022 - May 2024 (GPA - 3.77)',
  },
  {
    institution: 'Savitribai Phule Pune University',
    degree: 'Bachelor of Engineering in Electronics and Telecommunication',
    duration: 'Aug 2014 - May 2018 (GPA - 7.4)',
  },
]


const skills = [
  {
    category: 'Frontend',
    skills: [
      'HTML',
      'CSS',
      'JavaScript',
      'TypeScript',
      'React',
      'Redux',
      'SASS',
      'Material UI',
      'UX Design',
      'Figma'
    ]
  },
  {
    category: 'Backend',
    skills: [
      'Node.js',
      'Express',
      'Python',
      'Java',
      'C',
      'C++',
      'MongoDB',
      'GraphQL',
      'MySQL',
      'PostgreSQL',
      'Oracle SQL',
      'PL/SQL'
    ]
  },
  {
    category: 'Cloud',
    skills: [
      'AWS',
      'Docker',
      'Kubernetes',
      'CI/CD',
      'Apache Kafka',
      'Tableau'
    ]
  },
  // Add additional categories as needed
];

const contact = {
  email: 'rushikeshdalvi22@gmail.com',
}

export { header, about, projects, skills, contact, experience, education }
